import { gql } from '@apollo/client';

export const GENERATE_SIMULATION_MUTATION = gql`
  mutation GenerateSimulation($input: GenerateSimulationInput!) {
    generateSimulation(input: $input) {
      message {
        id
        role
        content
        htmlContent
        attachments {
          name
          type
        }
        createdAt
      }
    }
  }
`;
